import { Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ResponseUpdateItem, StepItemConfig } from '@sondermind/utilities/models-flows';

import { IconSizes, IrisIconComponent } from '@sondermind/iris/icon';
import { StepComponent } from '../step.component';

export interface IBaselineIntroConfig extends StepItemConfig {
  content?: string;
  infoText?: string;
}

@Component({
  selector: 'flows-baseline-intro',
  templateUrl: './baseline-intro.component.html',
  styleUrls: ['./baseline-intro.component.scss'],
  imports: [
    CommonModule,
    IrisIconComponent,
  ]
})
export class BaselineIntroComponent extends StepComponent<IBaselineIntroConfig> implements OnInit {
  irisIconSizes = IconSizes;

  get hasContext(): boolean {
    return !!this.wizard.context;
  }

  get staticIntroContent(): string {
    const content = this.hasContext ? this.wizard.context : this.config.content;

    return content ?? '';
  }

  get infoText(): string {
    const infoText = this.hasContext ? this.wizard.context : this.config.infoText;

    return infoText ?? '';
  }

  onSubmit(): ResponseUpdateItem[] {
    return [];
  }

  ngOnInit(): void {
    this.valid.next(!!this.component.next);
  }
}
